"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildWallet = void 0;
const ethers_1 = require("ethers");
const eth_1 = require("../../../lib/eth");
const chainConfiguration_1 = require("../../../lib/chainConfiguration");
const fetchManaBalance_1 = require("./fetchManaBalance");
function buildWallet(appChainId) {
    return __awaiter(this, void 0, void 0, function* () {
        const provider = yield (0, eth_1.getConnectedProvider)();
        if (!provider) {
            // This could happen if metamask is not installed
            throw new Error('Could not connect to Ethereum');
        }
        const eth = new ethers_1.ethers.providers.Web3Provider(provider);
        const accounts = yield eth.listAccounts();
        if (accounts.length === 0) {
            // This could happen if metamask was not enabled
            throw new Error('Could not get address');
        }
        const address = accounts[0].toString();
        const { chainId } = yield eth.getNetwork();
        const chainConfig = (0, chainConfiguration_1.getChainConfiguration)(chainId);
        const appChainConfig = (0, chainConfiguration_1.getChainConfiguration)(appChainId);
        const networks = {};
        for (const network of Object.keys(appChainConfig.networkMapping)) {
            const networkChainId = appChainConfig.networkMapping[network];
            networks[network] = {
                chainId: networkChainId,
                mana: yield (0, fetchManaBalance_1.fetchManaBalance)(networkChainId, address)
            };
        }
        return {
            address: address.toLowerCase(),
            providerType: (0, eth_1.getConnectedProviderType)(),
            networks: networks,
            network: chainConfig.network,
            chainId
        };
    });
}
exports.buildWallet = buildWallet;
//# sourceMappingURL=buildWallet.js.map